module.exports = __webpack_public_path__ + "caecefcfdca55d485d5453d9b065ea4b.svg";